'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectiveSelector$() {
  this.c6K = null;
  this.c6L = false;
  this.c6I = null;
  this.c6J = false;
  this.c6M = null;
  this.c6N = false;
  this.c6O = null;
  this.c6P = false;
}
export { $c_Lpresto_types$DirectiveSelector$ as $c_Lpresto_types$DirectiveSelector$ };
$p = $c_Lpresto_types$DirectiveSelector$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveSelector$;
/** @constructor */
function $h_Lpresto_types$DirectiveSelector$() {
}
export { $h_Lpresto_types$DirectiveSelector$ as $h_Lpresto_types$DirectiveSelector$ };
$h_Lpresto_types$DirectiveSelector$.prototype = $p;
$p.cJ2 = (function() {
  if ((!this.c6L)) {
    this.c6K = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c6L = true;
  }
  return this.c6K;
});
$p.vk = (function() {
  if ((!this.c6J)) {
    this.c6I = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c6J = true;
  }
  return this.c6I;
});
$p.cJL = (function() {
  if ((!this.c6N)) {
    this.c6M = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c6N = true;
  }
  return this.c6M;
});
$p.cK1 = (function() {
  if ((!this.c6P)) {
    this.c6O = new $c_Lpresto_types$DirectiveSelector$$anon$66(this);
    this.c6P = true;
  }
  return this.c6O;
});
$p.a3t = (function(str) {
  try {
    var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(document.querySelector(str));
  } catch (e) {
    var $x_1;
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a8 : e$2);
    }
  }
  return $x_1.sT();
});
var $d_Lpresto_types$DirectiveSelector$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveSelector$, "presto.types$DirectiveSelector$", ({
  ZO: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectiveSelector$ as $d_Lpresto_types$DirectiveSelector$ };
var $n_Lpresto_types$DirectiveSelector$;
function $m_Lpresto_types$DirectiveSelector$() {
  if ((!$n_Lpresto_types$DirectiveSelector$)) {
    $n_Lpresto_types$DirectiveSelector$ = new $c_Lpresto_types$DirectiveSelector$();
  }
  return $n_Lpresto_types$DirectiveSelector$;
}
export { $m_Lpresto_types$DirectiveSelector$ as $m_Lpresto_types$DirectiveSelector$ };
/** @constructor */
function $c_Lpresto_types$DirectiveSelector$$anon$66(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DirectiveSelector$$anon$66 as $c_Lpresto_types$DirectiveSelector$$anon$66 };
$p = $c_Lpresto_types$DirectiveSelector$$anon$66.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveSelector$$anon$66;
/** @constructor */
function $h_Lpresto_types$DirectiveSelector$$anon$66() {
}
export { $h_Lpresto_types$DirectiveSelector$$anon$66 as $h_Lpresto_types$DirectiveSelector$$anon$66 };
$h_Lpresto_types$DirectiveSelector$$anon$66.prototype = $p;
$p.bn = (function(it) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it);
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a8 : e$2);
    }
  }
});
$p.bO = (function(text) {
  return ($m_Lpresto_types$DirectiveSelector$().a3t(text) ? new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(text) : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), "CSS Selector is not valid")));
});
$p.bK = (function(t) {
  return this.bn(t);
});
var $d_Lpresto_types$DirectiveSelector$$anon$66 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveSelector$$anon$66, "presto.types$DirectiveSelector$$anon$66", ({
  ZP: 1,
  K: 1
}));
export { $d_Lpresto_types$DirectiveSelector$$anon$66 as $d_Lpresto_types$DirectiveSelector$$anon$66 };
//# sourceMappingURL=presto.types$-Directive-Selector$.js.map
